import isEmpty from 'lodash/isEmpty';

import { ApiProduct, RatePlan, Subscription } from '../types';
import { throwError } from './errorHandler';

// sort by descending order (Yearly --> Monthly)
const sortByBillingPeriod = (a: RatePlan, b: RatePlan) => b.billingPeriod.localeCompare(a.billingPeriod);

export const convertProductToRatePlan = (product: ApiProduct): RatePlan => ({
  amount: product.pricing.amount,
  billingPeriod: product.membership.periodType,
  currency: product.pricing.currency,
  trialLength: product.trial?.length,
});

export const getRatePlansFromProducts = (apiProducts: ApiProduct[]): RatePlan[] => {
  return apiProducts.map(convertProductToRatePlan).sort((a, b) => sortByBillingPeriod(a, b));
};

export const ratePlansFromSubscription = (currentSubscription: Subscription) => {
  const { recurringFee, alternativeBillingPeriods: altPlans } = currentSubscription;

  if (!recurringFee || isEmpty(altPlans)) {
    throwError('hubGeneralError', 'No rate plans found from current subscription');
  }

  const ratePlans = [recurringFee, ...altPlans!].toSorted(sortByBillingPeriod);
  return ratePlans;
};
